/* ============================================
   TOUCHE WELLNESS - Custom JavaScript
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ---- Scroll Reveal Animations ---- */
  const revealElements = document.querySelectorAll('.touche-reveal');
  if (revealElements.length) {
    const revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    revealElements.forEach(function (el) {
      revealObserver.observe(el);
    });
  }

  /* ---- Hero Age Tabs ---- */
  const heroTabBtns = document.querySelectorAll('.touche-hero__tab-btn');
  const heroTabPanels = document.querySelectorAll('.touche-hero__tab-panel');

  heroTabBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = this.getAttribute('data-tab');

      heroTabBtns.forEach(function (b) { b.classList.remove('active'); });
      heroTabPanels.forEach(function (p) { p.classList.remove('active'); });

      this.classList.add('active');
      var panel = document.getElementById(target);
      if (panel) panel.classList.add('active');
    });
  });

  /* ---- Timeline Scroll Animation ---- */
  var timelineSection = document.querySelector('.touche-timeline__line-fill');
  if (timelineSection) {
    var timelineObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate');
          // Activate milestone badges and dots
          var milestones = document.querySelectorAll('.touche-timeline__milestone-badge, .touche-timeline__milestone-dot');
          milestones.forEach(function (m, i) {
            setTimeout(function () {
              m.classList.add('active');
            }, 400 + (i * 300));
          });
          timelineObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });

    timelineObserver.observe(timelineSection);
  }

  /* ---- Before/After Avatar Switching ---- */
  var baAvatars = document.querySelectorAll('.touche-before-after__avatar');
  var baSlides = document.querySelectorAll('.touche-before-after__slide');

  baAvatars.forEach(function (avatar) {
    avatar.addEventListener('click', function () {
      var target = this.getAttribute('data-slide');

      baAvatars.forEach(function (a) { a.classList.remove('active'); });
      baSlides.forEach(function (s) { s.classList.remove('active'); });

      this.classList.add('active');
      var slide = document.getElementById(target);
      if (slide) {
        slide.classList.add('active');
        slide.style.animation = 'none';
        slide.offsetHeight;
        slide.style.animation = 'touche-fade-in 0.4s ease';
      }
    });
  });

  /* ---- Category Bar Tab Switching ---- */
  var catTabs = document.querySelectorAll('.touche-category-tabs a');
  catTabs.forEach(function (tab) {
    tab.addEventListener('click', function (e) {
      if (this.getAttribute('href') === '#') {
        e.preventDefault();
      }
      catTabs.forEach(function (t) { t.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  /* ---- Re-trigger line animation on hero visibility ---- */
  var heroLines = document.querySelectorAll('.touche-hero__line-path');
  if (heroLines.length) {
    var heroObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          heroLines.forEach(function (line) {
            line.style.animation = 'none';
            line.offsetHeight;
            line.style.animation = '';
          });
          heroObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    var heroVisual = document.querySelector('.touche-hero__visual');
    if (heroVisual) heroObserver.observe(heroVisual);
  }

});
